import { render } from "./YetkiYok.vue?vue&type=template&id=d0395126"
import script from "./YetkiYok.vue?vue&type=script&lang=js"
export * from "./YetkiYok.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__